import axios from 'axios'

const defaultHeaders = {
    'Content-Type': 'application/json',
}

const API_ENDPOINT = process.env?.REACT_APP_API_ENDPOINT;

console.log('api endpoint', API_ENDPOINT)

const API = axios.create({
    headers: defaultHeaders,
    baseURL: API_ENDPOINT,
})

export default API
